








import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import '@/assets/Mimity.js';
import '@/assets/styles.scss';
import { Watch } from 'vue-property-decorator';


@Component({})
export default class App extends Vue {

  @Action('loadProducts', { namespace: 'products' })
  protected loadProducts!: () => void;

  @Action('loadStoredAuth', { namespace: 'auth' })
  protected loadStoredAuth!: () => void;

  @Action('loadTranslations', { namespace: 'trans' })
  protected loadTranslations!: () => void;

  @Action('loadLanguages', { namespace: 'trans' })
  protected loadLanguages!: () => void;

  @Action('loadTranslationKeys', { namespace: 'trans' })
  protected loadTranslationKeys!: () => void;


  protected get layout() {
    const DEFAULT_LAYOUT = 'mimity-layout';
    const routeLayout = this.$route.meta.layout;

    if (!routeLayout) {
      return DEFAULT_LAYOUT;
    }

    return routeLayout.concat('-layout');
  }

  protected created() {
    this.loadProducts();
    this.loadLanguages();
    this.loadTranslationKeys();
    this.loadTranslations();
    this.loadStoredAuth();
  }
}
